import React from 'react'
import { Link } from 'react-router-dom'
import ls from "local-storage";
import * as CONFIG from './_config'

class Page extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    componentDidMount() {
        ls.set('redirectTo',window.location.href);
    }

    componentDidUpdate(prevProps, prevState) {
        ls.set('redirectTo',window.location.href);
    }

    render() {

      var Name = CONFIG.DATA.RSA_CLIENT_APP_NAME;
      Name = Name.replace(/-/g,' ');

    return (
        <div className="main-container full-width pt-5 mt-5">
        {   CONFIG.DATA.THEME === 2 ?
            <section id="apus-breadscrumb" className="breadcrumb-page apus-breadscrumb" style={{backgroundColor:'#f3ffd9'}}>
                <div className="container">
                    <div className="wrapper-breads">
                        <div className="wrapper-breads-inner">
                            <div className="breadscrumb-inner">
                                <h2 className="bread-title">Company Policies</h2>
                                <ol className="breadcrumb">
                                    <li>
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li>
                                        <Link to="/company-policies">Company Policies</Link>
                                    </li> 
                                    <li>
                                        <span>{Name}</span>
                                    </li> 
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            :
            <div className="title-breadcrumb">
                <div className="container">
                    <div className="title-breadcrumb-inner">
                        <header className="entry-header">
                            <h1 className="entry-title">{Name}</h1>
                        </header>
                        <div className="breadcrumbs">
                            <Link to="/">Home</Link>
                            <span className="separator">/</span>
                            <Link to="/company-policies">Company Policies</Link>
                            <span className="separator">/</span>
                            <span>{Name}</span>
                        </div>
                    </div>
                </div>
            </div>
        }

            <div className='container'>
                <div className="row">

                    <div className="vc_col-xs-12">
                        <div className="page-content default-page">
                            <article id="post-8436" className="post-8436 page type-page status-publish hentry">
                                <div className="entry-content">
                                    <div className="vc_row wpb_row vc_row-fluid">
                                        <div className="row-container" style={{/* marginLeft:'25%', marginTop:'25px'*/}} >
                                           <div className="wpb_column vc_column_container vc_col-sm-12 vc_col-md-12">
                                              <div className="vc_column-inner">
                                                 <div className="wpb_wrapper" style={{color:'#000'}} >
                                                    <div style={{textAlign: 'left'}} >
                                                        <h3 className="text-center" >Web Accessibility Statement</h3>
<br />
<p>We ({Name}) are committed to diversity, inclusion and accessibility in everything we do. These core values are fundamental to the way we do business and come through in the experiences we design for people &ndash; both in our stores and on the web.</p>

<p>With this in mind, we are continuously taking steps to improve {Name} and ensure it complies with the best practices and standards defined by Section 508 of the U.S. Rehabilitation Act and the Web Content Accessibility Guidelines of the World Wide Web Consortium.</p>

<p>Our website is monitored and tested periodically by internal and third-party accessibility consultants. To meet this commitment, we work with an independent agency to periodically assess and verify our site.</p>

<p>Further, we aim to adhere as closely as possible to the Web Content Accessibility Guidelines (WCAG), published by the World Wide Web Consortium (W3C).</p>

<p>These guidelines explain how to make Web content more accessible for people with disabilities. Conformance to these guidelines will help us provide a site that is more user friendly to everyone. These people help us identify usability issues and discover new solutions to further improve the accessibility of our site.</p>
<p><br /></p>
<b>Our Current Accessibility Features</b><br /><br />

<ul>
    <li>
    <p>Alternative text detail for appropriate images and other non-text elements.</p>
    </li>
    <li>
    <p>Title attributes for additional information about links and indication of new browser windows.</p>
    </li>
    <li>
    <p>Structural markup to indicate headings and lists to aid in page comprehension.</p>
    </li>
    <li>
    <p>Association of forms with labels.</p>
    </li>
    <li>
    <p>Association of all data cells in a data table with their headers.</p>
    </li>
    <li>
    <p>JavaScript and style sheets to enhance the appearance and functionality of the site. If these technologies are not available, alternative content is provided where necessary to ensure a usable experience.</p>
    </li>
    <li>
    <p>Further accessibility efforts are under way. As we continue to improve our website, we will reflect any changes here within our accessibility statement. That way you&rsquo;ll know about the progress we&rsquo;re making.</p>
    </li>
</ul>

<br />

<b>Feedback</b>

<p>We welcome your feedback on the accessibility of {Name}. Please let us know if you encounter accessibility barriers while using our site or have any comments and/or suggestions relating to improving the accessibility of our site. You can call us at <a href={`tel:${CONFIG.DATA.SUPPORT_PHONE}`}>{CONFIG.DATA.SUPPORT_PHONE}</a> or email us at <a href={`mailto:${CONFIG.DATA.SUPPORT_EMAIL}`}>{CONFIG.DATA.SUPPORT_EMAIL}</a> or <Link to="/contact">contact us</Link> through our support page. We will respond to your feedback as soon as possible.</p>

<br />

<h4><strong>Accessibility tips</strong></h4>

<p>To have the best experience of our site, we recommend that you take advantage of all opportunities to increase accessibility and customization that are available. The following two tips should help you:</p>

<p><strong>How to Change Text Size</strong></p>

<ul>
    <li>
    <p>On most browsers, try holding down the Ctrl key and scrolling the mouse wheel (if you have one), or hold down the Ctrl key and at the same time, push the - or + key.</p>
    </li>
    <li>
    <p>In Firefox and Internet Explorer, click the &quot;View&quot; menu, then select &quot;Zoom&quot; and then choose the whether you would like to increase the size (zoom in) or decrease the size (zoom out).</p>
    </li>
    <li>
    <p>In Google Chrome, click the customize button (spanner icon), then select the plus or minus buttons to zoom.</p>
    </li>
</ul>

<p><strong>How to Change Color Contrast</strong></p>

<p>To change the color contrast on your entire computer:</p>

<ul>
    <li>
    <p>For Windows computers, click &quot;Start&quot;, then &quot;Control Panel&quot;. Select the &quot;Accessibility</p>
    </li>
    <li>
    <p>For Apple Macs, select &quot;System Preferences&quot;, then &quot;Universal Access&quot;. Select the &quot;Seeing&quot; tab and adjust the &quot;Display&quot; section.</p>
    </li>
</ul>

<br />

<p><strong>To change the color contrast of websites on your browser:</strong></p>


<ul>
    <li>
    <p>In Internet Explorer, click &quot;Tools&quot;, then select &quot;Internet options.&quot; From within the &quot;General&quot; tab, click the &quot;Colors&quot; button. Deselect the &quot;Use Windows colors&quot; checkbox and change the color by selecting the color swatch. Then, select &quot;Accessibility&quot; within the &quot;Internet options&quot; window and select &quot;Ignore colors specified on web pages.&quot;</p>
    </li>
    <li>
    <p>In Firefox, click &quot;Tools&quot;, then select &quot;Options.&quot; From within the &quot;Colors&quot; tab, click the &quot;Colors&quot; button. Select the appropriate colors from the color swatch and un-tick the checkbox labeled &quot;Allow pages to choose their own colors, instead of my selections above&quot; and click OK.</p>
    </li>
    <li>
    <p>In Chrome, click &ldquo;Customize and Control Google Chrome&rdquo;, then Settings. Then click on &ldquo;Advanced&rdquo; then click &ldquo;Accessibility&rdquo;, then under Accessibility click Add Accessibility Feature. At Google Chrome web store, select Accessibility category and add appropriate extensions to the browser. You can also directly to chrome web store to find accessibility extensions by clicking this URL: <a target="_blank" href='https://chrome.google.com/webstore/category/ext/22-accessibility'>https://chrome.google.com/webstore/category/ext/22-accessibility</a></p>
    </li>
</ul>

<p><strong>If you are using a screen reader and having difficulty with this website, please call <a href={`tel:${CONFIG.DATA.SUPPORT_PHONE}`}>{CONFIG.DATA.SUPPORT_PHONE}</a></strong></p>
<br />

                                                    </div>
                                                    <div className="vc_empty_space" style={{height: '50px'}}><span className="vc_empty_space_inner"></span></div>
                                                 </div>
                                              </div>
                                           </div>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </div>   
                    </div>
                </div>
            </div>
        </div>
    )
    }
}
export default Page;



